const GET_RECENT_ATTACHMENTS = 'GET_RECENT_ATTACHMENTS'

const UPLOAD_ATTACHMENT = 'UPLOAD_ATTACHMENT'
const UPLOAD_ATTACHMENT_SUCCESS = 'UPLOAD_ATTACHMENT_SUCCESS'
const UPLOAD_ATTACHMENT_ERROR = 'UPLOAD_ATTACHMENT_ERROR'

const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT'
const DELETE_ATTACHMENT_SUCCESS = 'DELETE_ATTACHMENT_SUCCESS'
const DELETE_ATTACHMENT_ERROR = 'DELETE_ATTACHMENT_ERROR'

const GENERATE_OUTLINE = 'GENERATE_OUTLINE'
const GENERATE_OUTLINE_SUCCESS = 'GENERATE_OUTLINE_SUCCESS'
const GENERATE_OUTLINE_ERROR = 'GENERATE_OUTLINE_ERROR'

const GENERATE_COURSE = 'GENERATE_COURSE'
const GENERATE_COURSE_SUCCESS = 'GENERATE_COURSE_SUCCESS'
const GENERATE_COURSE_ERROR = 'GENERATE_COURSE_ERROR'

const UPDATE_OUTLINE = 'UPDATE_OUTLINE'
const UPDATE_OUTLINE_SUCCESS = 'UPDATE_OUTLINE_SUCCESS'
const UPDATE_OUTLINE_ERROR = 'UPDATE_OUTLINE_ERROR'

const CHECK_ATTACHMENT_STATUS_AI_CREATOR = 'CHECK_ATTACHMENT_STATUS_AI_CREATOR'
const CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR =
  'CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR'
const CHECK_ATTACHMENT_STATUS_ERROR_AI_CREATOR =
  'CHECK_ATTACHMENT_STATUS_ERROR_AI_CREATOR'

const GET_DOCUMENT_HEADERS = 'GET_DOCUMENT_HEADERS'
const GET_DOCUMENT_HEADERS_SUCCESS = 'GET_DOCUMENT_HEADERS_SUCCESS'
const GET_DOCUMENT_HEADERS_ERROR = 'GET_DOCUMENT_HEADERS_ERROR'

const ADD_ATTACHMENT_URL = 'ADD_ATTACHMENT_URL'
const ADD_ATTACHMENT_URL_SUCCESS = 'ADD_ATTACHMENT_URL_SUCCESS'
const ADD_ATTACHMENT_URL_ERROR = 'ADD_ATTACHMENT_URL_ERROR'

const GET_ATTACHMENT_TITLES = 'GET_ATTACHMENT_TITLES'
const GET_ATTACHMENT_TITLES_SUCCESS = 'GET_ATTACHMENT_TITLES_SUCCESS'
const GET_ATTACHMENT_TITLES_ERROR = 'GET_ATTACHMENT_TITLES_ERROR'

const CLEAR_OUTLINE = 'CLEAR_OUTLINE'

const SET_COURSE_ATTACHMENTS = 'SET_COURSE_ATTACHMENTS'

const SUGGEST_GOAL = 'SUGGEST_GOAL'
const SUGGEST_GOAL_SUCCESS = 'SUGGEST_GOAL_SUCCESS'
const SUGGEST_GOAL_ERROR = 'SUGGEST_GOAL_ERROR'

const SUGGEST_SECTION_TITLE = 'SUGGEST_SECTION_TITLE'
const SUGGEST_SECTION_TITLE_SUCCESS = 'SUGGEST_SECTION_TITLE_SUCCESS'
const SUGGEST_SECTION_TITLE_ERROR = 'SUGGEST_SECTION_TITLE_ERROR'

const SUGGEST_PAGE_TITLE = 'SUGGEST_PAGE_TITLE'
const SUGGEST_PAGE_TITLE_SUCCESS = 'SUGGEST_PAGE_TITLE_SUCCESS'
const SUGGEST_PAGE_TITLE_ERROR = 'SUGGEST_PAGE_TITLE_ERROR'

const SUGGEST_PAGE_OUTLINE = 'SUGGEST_PAGE_OUTLINE'
const SUGGEST_PAGE_OUTLINE_SUCCESS = 'SUGGEST_PAGE_OUTLINE_SUCCESS'
const SUGGEST_PAGE_OUTLINE_ERROR = 'SUGGEST_PAGE_OUTLINE_ERROR'

export {
  UPLOAD_ATTACHMENT,
  UPLOAD_ATTACHMENT_SUCCESS,
  UPLOAD_ATTACHMENT_ERROR,
  DELETE_ATTACHMENT,
  DELETE_ATTACHMENT_SUCCESS,
  DELETE_ATTACHMENT_ERROR,
  UPDATE_OUTLINE,
  UPDATE_OUTLINE_SUCCESS,
  UPDATE_OUTLINE_ERROR,
  CHECK_ATTACHMENT_STATUS_AI_CREATOR,
  CHECK_ATTACHMENT_STATUS_SUCCESS_AI_CREATOR,
  CHECK_ATTACHMENT_STATUS_ERROR_AI_CREATOR,
  GENERATE_OUTLINE,
  GENERATE_OUTLINE_SUCCESS,
  GENERATE_OUTLINE_ERROR,
  GENERATE_COURSE,
  GENERATE_COURSE_ERROR,
  GENERATE_COURSE_SUCCESS,
  GET_RECENT_ATTACHMENTS,
  GET_DOCUMENT_HEADERS,
  GET_DOCUMENT_HEADERS_SUCCESS,
  GET_DOCUMENT_HEADERS_ERROR,
  GET_ATTACHMENT_TITLES,
  GET_ATTACHMENT_TITLES_SUCCESS,
  GET_ATTACHMENT_TITLES_ERROR,
  CLEAR_OUTLINE,
  SUGGEST_GOAL,
  SUGGEST_GOAL_SUCCESS,
  SUGGEST_GOAL_ERROR,
  SUGGEST_SECTION_TITLE,
  SUGGEST_SECTION_TITLE_SUCCESS,
  SUGGEST_SECTION_TITLE_ERROR,
  SUGGEST_PAGE_TITLE,
  SUGGEST_PAGE_TITLE_SUCCESS,
  SUGGEST_PAGE_TITLE_ERROR,
  SUGGEST_PAGE_OUTLINE,
  SUGGEST_PAGE_OUTLINE_SUCCESS,
  SUGGEST_PAGE_OUTLINE_ERROR,

  ADD_ATTACHMENT_URL,
  ADD_ATTACHMENT_URL_SUCCESS,
  ADD_ATTACHMENT_URL_ERROR,
  SET_COURSE_ATTACHMENTS,
}
